import moment from "moment";

export interface TarifiedItemType {
  id: string;
  code: string;
  honorarium: number;
  officialHonorarium: number;
  patientFee: number;
  prestationDate: Date;
  prestationCodeText: string;
  reimbursement: number;
  attestNr: string;
}

export class TarifiedItem implements TarifiedItemType {
  id: string;
  code: string;
  honorarium: number;
  officialHonorarium: number;
  patientFee: number;
  prestationDate: Date;
  prestationCodeText: string;
  reimbursement: number;
  attestNr: string;

  constructor(data?: TarifiedItemType) {
    this.id = "";
    this.code = "";
    this.honorarium = 0;
    this.officialHonorarium = 0;
    this.patientFee = 0;
    this.prestationDate = moment().toDate();
    this.reimbursement = 0;
    this.prestationCodeText = "";
    this.attestNr = "";
    data && Object.assign(this, data);
  }
}
